import React from 'react';
import { MicrosoftFilesNode } from '../microsoftFiles';
export function SharePoint(props: any) { return <MicrosoftFilesNode {...props} provider="sharepoint"/>; }
